import React, { Component } from "react";
import cn from "classnames";
import PropTypes from "prop-types";

import EmojiStronglyDisagree from "../../../containers/assets/emoji-strongly-disagree.svg";
import EmojiDisagree from "../../../containers/assets/emoji-disagree.svg";
import EmojiNeutral from "../../../containers/assets/emoji-neutral.svg";
import EmojiAgree from "../../../containers/assets/emoji-agree.svg";
import EmojiStronglyAgree from "../../../containers/assets/emoji-strongly-agree.svg";
import PeerImage1 from "../../../containers/assets/peer_image1.png";
import PeerImage2 from "../../../containers/assets/peer_image2.png";
import PeerImage3 from "../../../containers/assets/peer_image3.png";
import PeerImage4 from "../../../containers/assets/peer_image4.png";
import PeerImage5 from "../../../containers/assets/peer_image5.png";
import PeerImage6 from "../../../containers/assets/peer_image6.png";

const Scale = {
  "Strongly Disagree": 1,
  Disagree: 2,
  Neutral: 3,
  Agree: 4,
  "Strongly Agree": 5
};

class LikertScaleTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValues: props.values
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { id, values } = this.props;

    if (prevProps.id !== id) {
      this.setState(() => ({ selectedValues: values }));
    }
  }

  getEmoji = key => {
    switch (key) {
      case "Strongly Disagree": {
        return EmojiStronglyDisagree;
      }
      case "Disagree": {
        return EmojiDisagree;
      }
      case "Neutral": {
        return EmojiNeutral;
      }
      case "Agree": {
        return EmojiAgree;
      }
      case "Strongly Agree": {
        return EmojiStronglyAgree;
      }
      default:
        break;
    }
  };

  handleOnSelect = (teammate, emoji) => {
    const { selectedValues } = this.state;
    const { feedbacks, readonlyMode } = this.props;

    if (readonlyMode) {
      return;
    }

    const feedback = feedbacks[teammate.id];
    if (!feedback) {
      return;
    }

    const newValues = [...selectedValues];
    let answerIndex = newValues.findIndex(i => i.feedback === feedback.id);
    let stateChanged = false;
    if (answerIndex === -1) {
      newValues.push({
        feedback: feedback.id,
        value: Scale[emoji],
      });
      stateChanged = true;
    } else if (answerIndex >= 0 && newValues[answerIndex].value !== Scale[emoji]) {
      newValues[answerIndex].value = Scale[emoji];
      stateChanged = true;
    }

    if (stateChanged) {
      this.setState({
        selectedValues: newValues,
      }, () => {
        const { onChange, id } = this.props;

        if (onChange) {
          onChange({
            id,
            value: Scale[emoji],
            type: "likert",
            hasError: false,
            feedback: feedback.id,
          });
        }
      });
    }
  };

  isEmojiSelected = (teammate, emoji) => {
    const { selectedValues } = this.state;
    const { feedbacks } = this.props;

    const feedback = feedbacks[teammate.id];
    if (!feedback) {
      return false;
    }

    const answer = selectedValues.find(i => i.feedback === feedback.id);
    if (!answer) {
      return false;
    }

    return answer.value === Scale[emoji];
  }

  renderTitle = title => {
    switch (title) {
      case "<contributingtoteamwork>":
        return <img src={PeerImage1} alt="contributingtoteamwork" />;
      case "<interactingwithteammates>":
        return <img src={PeerImage2} alt="interactingwithteammates" />;
      case "<keepteamontrack>":
        return <img src={PeerImage3} alt="keepteamontrack" />;
      case "<expectingquality>":
        return <img src={PeerImage4} alt="expectingquality" />;
      case "<knowledgeskillsabilities>":
        return <img src={PeerImage5} alt="knowledgeskillsabilities" />;
      case "<conflictmanagement>":
        return <img src={PeerImage6} alt="conflictmanagement" />;
      default:
        return title;
    }
  }

  render() {
    const { title, teamList, readonlyMode } = this.props;

    return (
      <div className="likertScaleTable">
        <div className="title">{this.renderTitle(title)}</div>
        <div className="likertScaleTableWrapper">
          <table>
            <tbody>
              <tr className="likertScaleTableHeader">
                <th></th>
                {Object.keys(Scale).map((item, index) => (
                  <th
                    key={`likert-scale-table-column-${index}`}
                    className="likertScaleTableEmojiColumn"
                  >
                    {item}
                  </th>
                ))}
                <th className="likertScaleTableEmptyColumn"></th>
              </tr>
              {teamList.map((teammate, teammateIndex) => (
                <tr key={`likert-scale-table-row-${teammateIndex}`} className={cn({
                  likertScaleTableGrayRow: teammateIndex % 2 === 0
                })}>
                  <td className="likertScaleTableUserName">{teammate.fullname}</td>
                  {Object.keys(Scale).map((item, index) => (
                    <td
                      key={`likert-scale-table-emoji-${teammateIndex}-${index}`}
                      className="likertScaleTableEmojiColumn"
                    >
                      <img
                        alt="emoji"
                        className={cn("likertScaleTableEmoji", {
                          likertScaleTableEmoji_selected: this.isEmojiSelected(teammate, item),
                          likertScaleTableEmoji_nofocus: readonlyMode,
                        })}
                        src={this.getEmoji(item)}
                        onClick={() => this.handleOnSelect(teammate, item)}
                      />
                    </td>
                  ))}
                  <td className="likertScaleTableEmptyColumn"></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

LikertScaleTable.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.shape({
    feedback: PropTypes.number,
    value: PropTypes.number,
  })),
  onChange: PropTypes.func,
  teamList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullname: PropTypes.string,
  })),
  readonlyMode: PropTypes.bool,
};

export default LikertScaleTable;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/likert-scale-table/index.js